var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-text-field',{attrs:{"label":"Name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.selectAnswer}},[_vm._v("Continue")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }